import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { FastFilter } from '@vlabs/uikit';

// eslint-disable-next-line import-x/no-namespace
import * as Popovers from '../popovers';

const withBottomPopover = withPopover({ placement: 'bottom-start' });
const withFastBottomPopover = withBottomPopover(FastFilter);

export const DateFilterWithBottomPopover = withFastBottomPopover(Popovers.DateFilterPopover);
export const FaceIdsFilterWithBottomPopover = withFastBottomPopover(Popovers.FaceIdsFilterPopover);
export const UserDataFilterWithBottomPopover = withFastBottomPopover(Popovers.UserDataFilterPopover);
